'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/monthFromNow.js
// module id = 367
// module chunks = 1